class DateFormatter {

    dateFormatUTC(dateStr, endOfDay = false) {
        if (dateStr == null) return null;

        const date = new Date(dateStr);

        if (endOfDay) {
            date.setHours(23, 59, 59, 999);
        } else {
            date.setHours(0, 0, 0, 0);
        }

        const localDate = new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
        return localDate.toISOString().slice(0, 19);
    }

    formatDate(date) {
        if (!date) return null;

        const [year, month, day] = date.split('T')[0].split('-');

        return `${day}/${month}/${year}`;
    }
}

export default new DateFormatter();